import { getCategoryColorClass, STATE_TO_BUCKET, STATUS_BUCKET } from '../constants';

const EMPTY_GROUP = { supported: false, items: [] };

const mapCapItem = (cap) => ({
  id: cap.id,
  name: cap.name,
  description: cap.description,
  scope: cap.scope,
  toolCount: cap.tool_count,
  activeInstances: cap.active_instances,
  totalInstances: cap.total_instances,
});

const mapGroup = (group) => ({
  supported: Boolean(group?.supported),
  items: (group?.items ?? []).map(mapCapItem),
});

const mapCapabilityGroups = (groups) => ({
  tools: mapGroup(groups?.tools ?? EMPTY_GROUP),
  knowledge: mapGroup(groups?.knowledge ?? EMPTY_GROUP),
  triggers: mapGroup(groups?.triggers ?? EMPTY_GROUP),
  channels: mapGroup(groups?.channels ?? EMPTY_GROUP),
  mcp: mapGroup(groups?.mcp ?? EMPTY_GROUP),
});

/**
 * Maps the provider-detail payload to the view model the Provider Detail header
 * and tabs render (CT-4186). Adds derived presentation fields; no client-side
 * status computation (the aggregate comes from the service, CT-4197).
 * ISO timestamps are kept raw; screens format them with `formatRelativeTime(..., t)` (CT-4995).
 */
export const mapApiProviderToUi = (p) => {
  if (!p) return null;
  return {
    slug: p.slug,
    name: p.name,
    official: Boolean(p.official),
    category: p.category,
    categoryColorClass: getCategoryColorClass(p.category),
    vendor: p.vendor ?? null,
    connectionState: p.connection_state, // 'connected' | 'not_connected'
    isConnected: p.connection_state === 'connected',
    status: p.status,
    statusBucket: STATE_TO_BUCKET[p.status] ?? STATUS_BUCKET.DISCONNECTED,
    authMethod: p.auth_method,
    lastRun: p.last_run ?? null,
    connectedAt: p.connected_at ?? null,
    connectedBy: p.connected_by,
    instances: p.instances ?? [],
    breakdown: p.breakdown ?? { working_count: 0, needs_attention_count: 0 },
    capabilities: p.capabilities ?? [],
    capabilityGroups: mapCapabilityGroups(p.capability_groups),
    studios: p.studios ?? {},
    about: p.about,
    useCases: p.use_cases ?? [],
    scopes: p.scopes ?? [],
    details: p.details ?? {},
  };
};
